export default __webpack_public_path__ + "static/media/Banner - Elevate Pro - Yellow-1.43fc5c1a.jpg";